import React from "react";

const About = () => {
  return (
    <div id="about" className="mb-48">
      <h1 className="text-5xl lg:text-6xl font-bold text-center mb-8 lg:mb-16">About Me</h1>
      <h2 className="lg:text-center text-md lg:text-lg text-justify lg:px-32">
        I’m a highly disciplined, progress-focused web developer with a
        long-standing background in web. I’ve worked on several web projects
        with MERN-stack and learning the ins and outs of many web technologies
        and libraries/packages that will be useful in the future. My enthusiasm
        for web development has always driven me to obtain a Bachelor of
        Computer Science degree.
      </h2>
      <div className="hidden lg:grid grid-cols-6 place-items-center gap-6 mt-10 ">
        <img
          className="w-full p-14"
          src="https://i.ibb.co/VYS3cdr/React-icon-svg.png"
          alt=""
        />
        <img
          className="w-full p-14"
          src="https://i.ibb.co/LrwJLk5/590px-Node-js-logo-svg.png"
          alt=""
        />
        <img
          className="w-full p-14"
          src="https://i.ibb.co/NSKxcff/png-transparent-mongodb-original-wordmark-logo-icon-thumbnail-removebg-preview.png"
          alt=""
        />
        <img
          className="w-full p-14"
          src="https://i.ibb.co/RYYjdnW/download-2-removebg-preview.png"
          alt=""
        />
        <img
          className="w-full p-14"
          src="https://i.ibb.co/Lnr8xqg/1-R4c8l-HBHu-H5qyq-Ot-Zb3h-w.png"
          alt=""
        />

        <img
          className="w-full p-14"
          src="https://i.ibb.co/7XQRq5Y/Tailwind-CSS-Logo-svg.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default About;
